import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import NavContext from "../context/NavContext";
import { addPropertiesById, mergeById } from "../utils/handleArray";
import Axios from "../_services/caller.service";

const useCabine = () => {
  const { ownerId, userAuth, majCabine, setMajCabine, realOwnerId } =
    useContext(NavContext);
  const [cabineByOwner, setCabineByOwner] = useState(null);
  const [numberDaysBeforeNextCalib, setNumberDaysBeforeNextCalib] = useState(
    []
  );

  useEffect(() => {
    if (!userAuth) return;
    const userCabine = ownerId != null ? ownerId : realOwnerId;
    let cancelled = false;

    Axios.get(`/cabinesCenter/${userCabine}`)
      .then(async (response) => {
        const cabineID = response.data.data || [];
        const allCabid = cabineID.map((cab) => cab.cabid.toString());

        // 1) Métadonnées des cabines + 2) données de calibration en PARALLÈLE
        //    (au lieu de N appels /dateOfLastCalibrationAndNumberDays/:id)
        const cabinesPromise = Axios.post(`/cabines/`, { data: allCabid })
          .then((res) => res.data?.data || [])
          .catch((err) => {
            console.log(err);
            return [];
          });

        const calibPromise = allCabid.length
          ? Axios.post(`/calibrationDaysBatch`, { cabIds: allCabid })
              .then((res) => res.data?.data || [])
              .catch((err) => {
                console.log(err);
                return [];
              })
          : Promise.resolve([]);

        const [dataCab, calibArray] = await Promise.all([
          cabinesPromise,
          calibPromise,
        ]);
        if (cancelled) return;

        // Fusion par id
        const calibById = new Map();
        for (const c of calibArray) calibById.set(c.id, c);

        const merged = dataCab.map((cab) => {
          const c = calibById.get(cab.id);
          return c ? { ...cab, ...c } : cab;
        });

        setCabineByOwner(merged);
      })
      .catch(function (error) {
        console.log(error);
      });

    return () => {
      cancelled = true;
    };
  }, [userAuth, ownerId, majCabine, setMajCabine]);

  return cabineByOwner;
};
export default useCabine;
